import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["title"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  return _openBlock(), _createElementBlock("span", {
    class: "language-switcher",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.toggleLocale && $options.toggleLocale(...args)),
    role: "button",
    title: _ctx.$t('language.switchTo')
  }, [_createVNode(_component_font_awesome_icon, {
    icon: "globe",
    class: "lang-icon"
  })], 8, _hoisted_1);
}